import type { TourStep } from '@/types/help-tour';
import { buildTourSteps, type TourStepDef } from '@/utils/tourI18n';

const STEP_DEFS: TourStepDef[] = [
  { target: '[data-tour="tree-header-actions"]' },
  { target: '[data-tour="tree-meta"]' },
  { target: '[data-tour="tree-stage"]' }
];

export const HYBRID_PEDIGREE_TOUR_STEPS: TourStep[] = buildTourSteps('hybridPedigree', STEP_DEFS);

export const HYBRID_PEDIGREE_TOUR_STORAGE_KEY = 'wetree-hybrid-pedigree-tour-completed';

export function resolveHybridPedigreeTourSteps(steps: TourStep[], hasTreeData: boolean): TourStep[] {
  if (hasTreeData) {
    return steps;
  }
  return steps.filter((step) => step.target !== '[data-tour="tree-stage"]');
}
